import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import QuickLink from './components/QuickLink';
import ScrollToTop from './components/ScrollToTop';
import LanguageRouter from './components/LanguageRouter';
import LanguageWrapper from './components/LanguageWrapper';


import './App.css';
import './styles/language-styles.css';

function App() {
  return (
    <LanguageProvider>
      <LanguageWrapper>
        <Router>
          <div className="App">
            <ScrollToTop />
            <LanguageRouter />
            <QuickLink />
          </div>
        </Router>
      </LanguageWrapper>
    </LanguageProvider>
  );
}

export default App;
